
    (function () {
      if (window.__phoneDropdownPortalInitialized) return;
      window.__phoneDropdownPortalInitialized = true;

      function initPhoneDropdown(root) {
        if (!root || root.dataset.phoneDropdownInited === 'true') return;
        root.dataset.phoneDropdownInited = 'true';

        var trigger = root.querySelector('[data-phone-dropdown-trigger]');
        var template = root.querySelector('[data-phone-dropdown-template]');
        if (!trigger || !template || !template.content.firstElementChild) return;

        var popup = template.content.firstElementChild.cloneNode(true);
        document.body.appendChild(popup);

        var mobileMq = window.matchMedia('(max-width: 767px)');
        var closeTimer = null;

        function clearCloseTimer() {
          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }
        }

        function positionPopup() {
          var rect = trigger.getBoundingClientRect();

          if (mobileMq.matches) {
            popup.style.position = 'fixed';
            popup.style.left = '12px';
            popup.style.right = '12px';
            popup.style.top = (rect.bottom + 8) + 'px';
            popup.style.minWidth = '0';
            popup.style.maxWidth = 'none';
          } else {
            popup.style.position = 'absolute';
            popup.style.right = 'auto';
            popup.style.left = (window.scrollX + rect.left) + 'px';
            popup.style.top = (window.scrollY + rect.bottom + 8) + 'px';
            popup.style.minWidth = 'max-content';
            popup.style.maxWidth = 'calc(100vw - 24px)';

            var popupRect = popup.getBoundingClientRect();
            if (popupRect.right > window.innerWidth - 12) {
              var shiftedLeft = Math.max(12, window.scrollX + rect.right - popupRect.width);
              popup.style.left = shiftedLeft + 'px';
            }
          }
        }

        function openPopup() {
          clearCloseTimer();
          document.querySelectorAll('.phone-dropdown__portal.is-open').forEach(function (node) {
            if (node !== popup) node.classList.remove('is-open');
          });
          document.querySelectorAll('[data-phone-dropdown].is-open').forEach(function (node) {
            if (node !== root) node.classList.remove('is-open');
          });
          document.querySelectorAll('[data-phone-dropdown-trigger][aria-expanded="true"]').forEach(function (node) {
            if (node !== trigger) node.setAttribute('aria-expanded', 'false');
          });

          positionPopup();
          popup.classList.add('is-open');
          root.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }

        function closePopup() {
          clearCloseTimer();
          popup.classList.remove('is-open');
          root.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }

        function scheduleClose() {
          clearCloseTimer();
          closeTimer = setTimeout(closePopup, 120);
        }

        if (!mobileMq.matches) {
          root.addEventListener('mouseenter', openPopup);
          root.addEventListener('mouseleave', scheduleClose);
          trigger.addEventListener('focus', openPopup);
        }

        popup.addEventListener('mouseenter', clearCloseTimer);
        popup.addEventListener('mouseleave', scheduleClose);

        trigger.addEventListener('click', function (event) {
          if (!mobileMq.matches) return;
          event.preventDefault();
          event.stopPropagation();

          if (root.classList.contains('is-open')) {
            closePopup();
          } else {
            openPopup();
          }
        });

        document.addEventListener('click', function (event) {
          if (root.contains(event.target) || popup.contains(event.target)) return;
          closePopup();
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            closePopup();
          }
        });

        window.addEventListener('resize', function () {
          if (root.classList.contains('is-open')) {
            positionPopup();
          }
        });

        window.addEventListener('scroll', function () {
          if (root.classList.contains('is-open')) {
            if (mobileMq.matches) {
              positionPopup();
            } else {
              positionPopup();
            }
          }
        }, { passive: true });

        if (mobileMq.addEventListener) {
          mobileMq.addEventListener('change', function () {
            closePopup();
          });
        } else if (mobileMq.addListener) {
          mobileMq.addListener(function () {
            closePopup();
          });
        }
      }

      function initAllPhoneDropdowns(scope) {
        var nodes = scope.querySelectorAll('[data-phone-dropdown]');
        nodes.forEach(initPhoneDropdown);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          initAllPhoneDropdowns(document);
        });
      } else {
        initAllPhoneDropdowns(document);
      }

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof Element)) return;

            if (node.matches && node.matches('[data-phone-dropdown]')) {
              initPhoneDropdown(node);
            }

            if (node.querySelectorAll) {
              initAllPhoneDropdowns(node);
            }
          });
        });
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    })();
  